import { IColumns } from '../../../components/Table'

export type CompanyDetailsOfUsersColumnKeys = 'name' | 'role' | 'kycStatus' | 'riskScore' | 'actions'

export const columns: IColumns<CompanyDetailsOfUsersColumnKeys>[] = [
  {
    id: 'name',
    label: 'NAME',
  },
  {
    id: 'role',
    label: 'USER TYPE',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'kycStatus',
    label: 'STATUS',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'riskScore',
    label: 'RISK SCORE',
    format: (value) =>
      value
        ?.toString()
        .replace('_', ' ')
        .replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]
